import * as pkg from "./../package.json";
import { createApp } from "vue";
import App from "./App.vue";

// Leaflet
import "./../node_modules/leaflet/dist/leaflet.js";
import "./../node_modules/leaflet/dist/leaflet.css";

import "./leaflet.css"; // custom overrides

delete L.Icon.Default.prototype._getIconUrl; // workaround

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("./../node_modules/leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("./../node_modules/leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("./../node_modules/leaflet/dist/images/marker-shadow.png"),
});

// create vue app
const packageJson = pkg;
const { name } = packageJson;
const app = createApp(App);
const containerElement = document.querySelector(`#${name}`);
app.provide("containerElement", containerElement);
app.mount(containerElement);
